import { Component, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxScrollViewModule }  from 'devextreme-angular/ui/scroll-view';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, RouterModule } from "@angular/router";
import { filter } from 'rxjs/operators';
import {AppConfigService} from '../../app-config.service';
import { Configuration } from '../../app.constants';

interface IBreadcrumb {
  label: string;
  params?: Params;
  url: string;
}

@Component({
  selector: 'app-single-card',
  templateUrl: './single-card.component.html',
  styleUrls: ['./single-card.component.scss'],
})
export class SingleCardComponent {
  public breadcrumbs: IBreadcrumb[];
  public headerLabel :string ="Homed";
  public logoPath :string="";
  LanguageLabel: any;
  public ApplicationTitle:string="";
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appConfigService : AppConfigService,private Configuration:Configuration
  ) {
    this.breadcrumbs = [];
    this.logoPath = this.appConfigService.LogoPath;
  }

  ngOnInit() {
    
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    //subscribe to the NavigationEnd event
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      //set breadcrumbs
      let root: ActivatedRoute = this.activatedRoute.root;
      this.breadcrumbs = this.getBreadcrumbs(root);
    });
  }
  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    //console.log('1',route);
    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      //append route URL to URL
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: IBreadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        params: child.snapshot.params,
        url: url
      };
      this.headerLabel = child.snapshot.data["headerLabel"];
      if (breadcrumbs.length === 0) {
        breadcrumbs.push(breadcrumb);
      }
      else {
        if (breadcrumbs.filter(item => item.label === breadcrumb.label).length === 0) {
          breadcrumbs.push(breadcrumb);
        }
      }


      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }

    //we should never get here, but just in case
    return breadcrumbs;
  }
}

@NgModule({
  imports: [ CommonModule, DxScrollViewModule ],
  exports: [ SingleCardComponent ],
  declarations: [ SingleCardComponent ]
})
export class SingleCardModule { }
